import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/z/work/lux-apps/web/app/market/src/app/[slug]/content.tsx");
